export const passwordValidationWeak = password => {
  return password.length > 4;
};

export const passwordValidation = password => {
  return new RegExp(/(?=.{8,16})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()])/).test(password);
};

export const validatePasswordLength = password => {
  return new RegExp(/(?=.{8,16})/).test(password);
};

export const validatePasswordHasNumber = password => {
  return new RegExp(/(?=.*\d)/).test(password);
};

export const validatePasswordHasUpper = password => {
  return new RegExp(/(?=.*[A-Z])/).test(password);
};

export const validatePasswordHasLower = password => {
  return new RegExp(/(?=.*[a-z])/).test(password);
};

export const validatePasswordHasSpecialChar = password => {
  return new RegExp(/(?=.*[!@#$%&*()])/).test(password);
};

export const passwordConfirmationValidation = (password, passwordConfirmation) => {
  if (password === '' || passwordConfirmation === '') return false;
  return password === passwordConfirmation;
};
